import { useProductsByCategory } from '@/services/api/hooks/product';
import { useMemo } from 'react';

export interface SpecGroup {
  type: string | null;
  specs: string[];
}

export const useBuildGroupedSpecifications = (categoryId?: string) => {
  const [products] = useProductsByCategory(categoryId);

  return useMemo(() => {
    const groupedProperties: SpecGroup[] = [];

    products.forEach(item => {
      item.propertyBag.properties.forEach(property => {
        const existingGroup = groupedProperties.find(
          (group: SpecGroup) => group.type?.toUpperCase() === property.iconId?.toUpperCase()
        );
        if (existingGroup) {
          existingGroup.specs.push(property.text);

          existingGroup.specs = Array.from(new Set(existingGroup.specs));
        } else {
          groupedProperties.push({
            type: property.iconId ? property.iconId.toUpperCase() : null,
            specs: [property.text]
          });
        }
      });
    });

    // Check for any null type groups and group under "Other"
    const nonNullTypes = groupedProperties.filter(item => item.type !== null);
    const nullTypes = groupedProperties.filter(item => item.type === null);

    if (nullTypes.length > 0) {
      const combinedNullValues = nullTypes.reduce((acc, item) => acc.concat(item.specs), [] as string[]);
      nonNullTypes.push({ type: 'OTHER', specs: combinedNullValues });
    }

    return nonNullTypes;
  }, [products]);
};
